import type { I18nLocale } from "@/modules/i18n/types"

export const DEFAULT_LOCALE: I18nLocale = "en"

/**
 * This list is related to the opened public WWW website.
 */
export const PUBLIC_LOCALES: I18nLocale[] = ["fr", "da", "de", "es", "nl", "en"]

/**
 * This list is related to non opened locales WWW website.
 */
export const NON_OPENED_LOCALES: I18nLocale[] = ["ca", "cs", "fi", "gl", "it", "no", "pl", "pt", "sv"]

export const LANGUAGES_ISO_639_1_CODES = [
  "aa",
  "ab",
  "af",
  "ak",
  "sq",
  "am",
  "ar",
  "an",
  "hy",
  "as",
  "av",
  "ae",
  "ay",
  "az",
  "ba",
  "bm",
  "eu",
  "be",
  "bn",
  "bh",
  "bi",
  "bs",
  "br",
  "bg",
  "my",
  "ca",
  "ch",
  "ce",
  "zh",
  "cu",
  "cv",
  "kw",
  "co",
  "cr",
  "cs",
  "da",
  "dv",
  "nl",
  "dz",
  "en",
  "eo",
  "et",
  "ee",
  "fo",
  "fj",
  "fi",
  "fr",
  "fy",
  "ff",
  "ka",
  "de",
  "gd",
  "ga",
  "gl",
  "gv",
  "el",
  "gn",
  "gu",
  "ht",
  "ha",
  "he",
  "hz",
  "hi",
  "ho",
  "hr",
  "hu",
  "ig",
  "is",
  "io",
  "ii",
  "iu",
  "ie",
  "ia",
  "id",
  "ik",
  "it",
  "jv",
  "ja",
  "kl",
  "kn",
  "ks",
  "kr",
  "kk",
  "km",
  "ki",
  "rw",
  "ky",
  "kv",
  "kg",
  "ko",
  "kj",
  "ku",
  "lo",
  "la",
  "lv",
  "li",
  "ln",
  "lt",
  "lb",
  "lu",
  "lg",
  "mk",
  "mh",
  "ml",
  "mi",
  "mr",
  "ms",
  "mg",
  "mt",
  "mn",
  "na",
  "nv",
  "nr",
  "nd",
  "ng",
  "ne",
  "nn",
  "nb",
  "no",
  "ny",
  "oc",
  "oj",
  "or",
  "om",
  "os",
  "pa",
  "fa",
  "pi",
  "pl",
  "pt",
  "ps",
  "qu",
  "rm",
  "ro",
  "rn",
  "ru",
  "sg",
  "sa",
  "si",
  "sk",
  "sl",
  "se",
  "sm",
  "sn",
  "sd",
  "so",
  "st",
  "es",
  "sc",
  "sr",
  "ss",
  "su",
  "sw",
  "sv",
  "ty",
  "ta",
  "tt",
  "te",
  "tg",
  "tl",
  "th",
  "bo",
  "ti",
  "to",
  "tn",
  "ts",
  "tk",
  "tr",
  "tw",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "cy",
  "wa",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zu",
] as const

export const LANGUAGE_PROFICIENCIES = [
  "elementary",
  "limited_working",
  "professional_working",
  "full_professional",
  "native",
] as const

export const PROFICIENCY_ORDER_MAPPING: { [key in (typeof LANGUAGE_PROFICIENCIES)[number]]: number } = {
  elementary: 0,
  full_professional: 3,
  limited_working: 1,
  native: 4,
  professional_working: 2,
}
